const TestTubeIcon = ({ className = '' }) => {
  return (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.8787 3.87868C38.0503 2.70711 39.9497 2.70711 41.1213 3.87868L68.1213 30.8787C69.2929 32.0503 69.2929 33.9497 68.1213 35.1213C66.9497 36.2929 65.0503 36.2929 63.8787 35.1213L62.3988 33.6414C62.3115 33.7409 62.2204 33.8382 62.1255 33.9332L35.0268 61.0318C28.4037 67.6552 17.6098 67.6552 10.9866 61.0319L10.984 61.0293C7.66832 57.7094 6.02868 53.343 6.00013 49.0506L6 49.0107C6 44.6345 7.69158 40.2883 10.9843 36.9918L38.0858 9.8929C38.1806 9.79806 38.2778 9.70707 38.3773 9.61991L36.8787 8.12132C35.7071 6.94975 35.7071 5.05025 36.8787 3.87868ZM57.8829 29.6905L42.3282 14.1357L36.4914 19.972C36.8166 20.2954 37.0722 20.6984 37.2248 21.1641C37.6769 22.5442 39.1693 24.9237 44.3883 26.9623L44.3998 26.9668C49.1141 28.8309 52.0721 31.2266 53.7585 33.8149L57.8829 29.6905ZM49.4419 38.1315C49.2598 37.9427 49.0996 37.7267 48.9678 37.4853C48.2429 36.158 46.4843 34.2441 42.1992 32.5487C36.6375 30.375 33.5417 27.4486 32.0708 24.3921L15.2294 41.232C13.0907 43.3731 12 46.1812 12 49.0107C12.0187 51.8187 13.0907 54.6479 15.2294 56.7893C19.5094 61.0695 26.5041 61.0695 30.784 56.7893L31.1653 56.408L27.8787 53.1213C26.7071 51.9497 26.7071 50.0503 27.8787 48.8787C29.0503 47.7071 30.9497 47.7071 32.1213 48.8787L35.408 52.1653L40.2818 47.2915L40.2784 47.2881L34.4251 41.4348C33.2535 40.2632 33.2535 38.3637 34.4251 37.1922C35.5966 36.0206 37.4961 36.0206 38.6677 37.1922L44.521 43.0455L44.5245 43.0489L49.4419 38.1315Z"
        fill="#FF9060"
      />
    </svg>
  )
}

export default TestTubeIcon
